import { Pipe, PipeTransform } from '@angular/core';
import { FacilityType } from '@rivethealth/data/location';

@Pipe({ name: 'facility' })
export class FacilityPipe implements PipeTransform {
  transform(value: FacilityType): string {
    switch (value) {
      case 'facility':
        return 'Professional facility';
      case 'non-facility':
        return 'Professional non-facility';
      case 'asc':
        return 'ASC - technical';
    }
  }
}
